// extracted by extract-css-chunks-webpack-plugin
module.exports = {"subnavigation":"_1qkdQl","item":"QJKGzm","link":"_37t4B1"};